export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 3,
				text: "The lecturer was not able to contribute to a productive learning and working atmosphere.",
			},
			{
				id: 4,
				text: "The lecturer provided the opportunity to discuss the content.",
			},
			{
				id: 5,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 6,
				text: "The lecturer was knowledgeable with regard to the scope of the course.",
			},
			{
				id: 7,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 8,
				text: "The participants’ comprehension was important to the lecturer.",
			},
			{
				id: 9,
				text: "The lecturer contributed to a motivating learning atmosphere.",
			},
			{
				id: 10,
				text: "The learning objectives for the course were transparent.",
			},
			{
				id: 11,
				text: "The learning objectives were well defined.",
			},
			{
				id: 12,
				text: "The course was clearly structured.",
			},
			{
				id: 13,
				text: "The combination of the learning activities facilitated the learning objectives.",
			},
			{
				id: 14,
				text: "The combination of the learning activities was well defined.",
			},
			{
				id: 15,
				text: "I was interested in the subject of the course.",
			},
			{
				id: 16,
				text: "The topic of the course is relevant to my study program.",
			},
			{
				id: 17,
				text: "I feel that I learned a lot in this course.",
			},
			{
				id: 18,
				text: "The topic of the course is relevant for my professional goals.",
			},
			{
				id: 19,
				text: "The difficulty of the content was appropriate for the learning objectives.",
			},
			{
				id: 20,
				text: "The amount of the covered content was too much.",
			},
			{
				id: 21,
				text: "The pace of the course was appropriate for the level of my study program.",
			},
			{
				id: 22,
				text: "The amount of work required for the course was too time consuming for the number of ECTS.",
			},
			{
				id: 23,
				text: "The course was too difficult for me.",
			},
			{
				id: 24,
				text: "I did not feel challengend enough.",
			},
			{
				id: 25,
				text: "I found most of the topics covered too difficult.",
			},
			{
				id: 26,
				text: "Overall, this was a good course.",
			},
			{
				id: 27,
				text: "I learned a lot in this course.",
			},
			{
				id: 28,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 29,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 30,
				text: "Further remarks regarding the course (praise/criticism)",
			},
		],
	},
	{
		type: "age",
		id: 3,
		items: [
			{
				id: 31,
				text: "Age: ",
			},
		],
	},
];
